import { render, staticRenderFns } from "./NotificationOverview.vue?vue&type=template&id=458b9792&scoped=true&"
import script from "./NotificationOverview.vue?vue&type=script&lang=js&"
export * from "./NotificationOverview.vue?vue&type=script&lang=js&"
import style0 from "./NotificationOverview.vue?vue&type=style&index=0&id=458b9792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458b9792",
  null
  
)

export default component.exports